import React, { FC } from 'react';
import { Text, View } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import { MACHINES_PAGES_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import EventCharts, { EventCharts as EventChartsInnerComponent } from '@components/machines/components/eventsChart';

interface NCFilePerformanceProductiveProps extends NavigationProps {}

const NCFilePerformanceProductive: FC<NCFilePerformanceProductiveProps> = ({ lg }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
    >
      <View style={MACHINES_PAGES_CONTAINER_STYLES}>
        <EventCharts getContentElement={(props) => <EventChartsInnerComponent {...props} />} />
      </View>
    </MachinesProvider>
  );
};

export { NCFilePerformanceProductive };
